import React from 'react'
import Footer from '../Footer/Footer'
import Header from '../Header'
import Guidelinehero from './Guidelinehero'

const Guideline = () => {
  return (
    <div>
        <Header />
        <Guidelinehero />
        <Footer />
    </div>
  )
}

export default Guideline